/* eslint-disable react/display-name */
import React, {
    PureComponent, useState, useRef, useCallback, useEffect,
} from 'react'
import { Navbar } from 'react-bulma-components'
import {
    DirectionalHint,
    Icon, Panel, TextField, TooltipDelay, TooltipHost,
} from '@fluentui/react'
import history from 'helpers/history'
import enhanceWithClickOutside from 'react-click-outside'
import { Link } from 'react-router-dom'
import User from 'requests/objects/user'
import ExportHandler from 'requests/handlers/exportHandler'

const Header = enhanceWithClickOutside(
    /**
     * @typedef {object} HeaderProps
     * @property {import('pages/_layout').MenuElement[]} menu Menu to display
     * @property {User} me User informations
     * @property {object} param Constants
     * @property {function():void} signOut Sign out
     * @property {function():void} refresh Refresh app
     * @property {ExportHandler} exportHandler exportHandler
     * @augments {PureComponent<HeaderProps>}}
     */
    // @ts-ignore
    class extends PureComponent {
        constructor(props) {
            super(props)
            this.state = {
                /** @type {boolean} Is burger menu open on mobile */
                isActive: false,
                /** @type {boolean} Is Panel user open */
                isOpenUser: false,
                // /** @type {boolean} agentIsActive */
                // agentIsActive: false,
            }
        }

        /**
         * Handle click outside component
         */
        handleClickOutside() {
            this.setState({ isActive: false })
        }

        /**
         * Render component
         * @returns {JSX.Element} Element
         */
        render() {
            const {
                menu, me, signOut, refresh, exportHandler,
            } = this.props

            const { isActive, isOpenUser } = this.state

            return (
                <>
                    <Navbar
                        active={isActive}
                        transparent={false}
                    >
                        <Navbar.Brand>
                            <Navbar.Item
                                renderAs="a"
                                onClick={() => history.push('/')}
                            >
                                <img
                                    // eslint-disable-next-line global-require
                                    src={require('assets/img/logo.png').toString()}
                                    alt={process.env.REACT_APP_SHORT_NAME}
                                />
                                <span>
                                    {' '}
                                    {process.env.REACT_APP_SHORT_NAME}
                                </span>
                            </Navbar.Item>
                            <Navbar.Item
                                style={{
                                    margin: 0,
                                    position: 'absolute',
                                    padding: 0,
                                    paddingTop: '10px',
                                    left: '50%',
                                    transform: 'translate(-50%, 0)',
                                }}
                                className="is-hidden-touch"
                                onClick={() => history.push('/')}
                            >
                                <ConnectionButton
                                    exportHandler={exportHandler}
                                />
                            </Navbar.Item>
                            <Navbar.Burger onClick={() => this.setState({ isActive: !isActive })} />
                        </Navbar.Brand>
                        <Navbar.Menu>
                            <Navbar.Container className="is-hidden-desktop">
                                {
                                    menu.map((x, i) => (
                                        // eslint-disable-next-line react/no-array-index-key
                                        <Navbar.Item key={i}>
                                            {
                                                x.name
                                                && (
                                                    <Navbar.Link arrowless>
                                                        {x.name}
                                                    </Navbar.Link>
                                                )
                                            }
                                            <Navbar.Dropdown>
                                                {
                                                    x?.links.map((y, j) => (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <React.Fragment key={`${i}_${j}`}>
                                                            <Link
                                                                className="navbar-item"
                                                                to={y.key}
                                                                onClick={() => this.setState({ isActive: false })}
                                                            >
                                                                <Icon iconName={y.icon} />
                                                                <span>
                                                                    {' '}
                                                                    {y.title}
                                                                </span>
                                                            </Link>
                                                            {
                                                                y?.links?.length
                                                                && y?.links.map((z, k) => (
                                                                    <Link
                                                                        // eslint-disable-next-line react/no-array-index-key
                                                                        key={`${i}_${j}_${k}`}
                                                                        className="navbar-item"
                                                                        to={z.key}
                                                                        onClick={() => this.setState({ isActive: false })}
                                                                    >
                                                                        <Icon iconName={z.icon} />
                                                                        <span>
                                                                            {' '}
                                                                            {z.title}
                                                                        </span>
                                                                    </Link>
                                                                ))
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </Navbar.Dropdown>
                                        </Navbar.Item>
                                    ))
                                }
                                <Navbar.Item>
                                    <Navbar.Link arrowless>
                                        Autre
                                    </Navbar.Link>
                                    <Navbar.Dropdown>
                                        <Navbar.Item
                                            onClick={() => this.setState({ isActive: false }, () => refresh())}
                                        >
                                            <Icon iconName="Refresh" />
                                            {' '}
                                            Rafraichir
                                        </Navbar.Item>
                                        <Navbar.Item
                                            onClick={() => this.setState({ isOpenUser: true })}
                                        >
                                            <Icon iconName="Contact" />
                                            {' '}
                                            Utilisateur
                                        </Navbar.Item>
                                        <Navbar.Item
                                            onClick={() => signOut()}
                                        >
                                            <Icon iconName="SignOut" />
                                            {' '}
                                            Se déconnecter
                                        </Navbar.Item>
                                    </Navbar.Dropdown>
                                </Navbar.Item>
                            </Navbar.Container>
                            <Navbar.Container
                                align="right"
                                className="is-hidden-touch"
                            >
                                <Navbar.Item
                                    className="is-tab"
                                    onClick={() => refresh()}
                                >
                                    <Icon iconName="Refresh" />
                                </Navbar.Item>
                                <Navbar.Item
                                    className="is-tab"
                                    onClick={() => this.setState({ isOpenUser: true })}
                                >
                                    <Icon iconName="Contact" />
                                </Navbar.Item>
                                <Navbar.Item
                                    className="is-tab"
                                    onClick={() => signOut()}
                                >
                                    <Icon iconName="SignOut" />
                                </Navbar.Item>
                            </Navbar.Container>
                        </Navbar.Menu>
                    </Navbar>
                    <Panel
                        className="panel-user"
                        headerText="Votre compte"
                        isLightDismiss
                        isOpen={isOpenUser}
                        onDismiss={() => this.setState({ isOpenUser: false })}
                        closeButtonAriaLabel="Close"
                    >
                        <br />
                        <TextField
                            label="Nom"
                            value={`${me?.lastname ?? ''} ${me?.firstname ?? ''}`}
                            borderless
                            readOnly
                        />
                    </Panel>
                </>
            )
        }
    },
)

export default Header

/**
 * Connection button
 * @param {object} props Props
 * @param {ExportHandler} props.exportHandler exportHandler
 * @returns {JSX.Element} Returns
 */
function ConnectionButton({
    exportHandler,
}) {
    const [agentIsActive, setAgentIsActive] = useState(undefined)
    /** @type {React.MutableRefObject<NodeJS.Timer>} */
    const timerRef = useRef(null)

    /** @type {React.MutableRefObject<import('requests/apiHandler').RequestApi<boolean>>} */
    const statusHandler = useRef(null)

    const fetchAgentStatus = useCallback(async () => {
        try {
            statusHandler.current = exportHandler.getAgentStatus()
            const isActive = await statusHandler.current.fetch()
            setAgentIsActive(isActive)
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error)
            setAgentIsActive(false)
        }
    }, [exportHandler])

    // Handle auto save
    useEffect(() => {
        fetchAgentStatus()
        clearInterval(timerRef.current)
        timerRef.current = setInterval(() => fetchAgentStatus(), 15000)
        return () => {
            clearInterval(timerRef.current)
        }
    }, [fetchAgentStatus])

    if (agentIsActive === undefined)
        return null

    return (
        <TooltipHost
            content={agentIsActive
                ? "L'agent est opérationnel"
                // eslint-disable-next-line max-len
                : "La communication entre le portail et l'agent qui exécute les exports est interrompu, vous pouvez tout de même réaliser vos exports. Ils s'exécuteront lorsque la connexion sera rétablie."}
            directionalHint={DirectionalHint.bottomAutoEdge}
            delay={TooltipDelay.medium}
            styles={{
                root: {
                    paddingTop: '8px',
                },
            }}
        >

            <div
                style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    position: 'relative',
                    backgroundColor: agentIsActive ? '#0acf28' : '#e0190b',
                    // margin: '5px',
                    boxShadow: `0 0 0 2px ${agentIsActive ? '#067316' : '#730d06'}`,
                }}
            />
        </TooltipHost>
    )
}
